import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import apiClient from "../api.js";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux"; // <-- Add this

const Leads = () => {
  const [results, setResults] = useState([]);
  const [followUpValues, setFollowUpValues] = useState({}); // State to track follow-up values
  const notify = () => toast("Record Updated Successfully!");
  useEffect(() => {
    fectchLeads();
  }, []);

  const fectchLeads = async () => {
    try {
      const response = await apiClient.post("leaddata/leads");

      const leads = response.data;

      setResults(leads);

      // Initialize follow-up values for each lead
      const initialFollowUps = {};
      leads.forEach((lead) => {
        initialFollowUps[lead._id] = lead.followUp || ""; // Use lead's existing follow-up or empty string
      });
      setFollowUpValues(initialFollowUps);
    } catch (error) {
      console.error("No data Found", error);
    }
  };

  const updateFollowup = async (id) => {
    try {
      const response = await apiClient.post("leaddata/updatefollowup", {
        id,
        followUp: followUpValues[id],
      });

      if (response) {
        notify();
      }
    } catch (error) {
      console.error("Something Went Wrong", error);
    }
  };

  const handleFollowUpChange = (id, value) => {
    setFollowUpValues({
      ...followUpValues,
      [id]: value,
    });
  };

  const { currentUser } = useSelector((state) => state.user); // <-- Access user here
  // console.log(currentUser._id);
  if (currentUser.role !== "Admin") {
    return (
      <h1 className="text-center">You are not authorized to view this page</h1>
    );
  }
  return (
    <>
      <Helmet>
        <title>Find Your Perfect Home at Best Deals | Homes Dekho</title>
        <meta
          name="description"
          content="Find Your Perfect Home at Best Deals | Homes Dekho"
        />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div>
              <h1 className="text-center">All Leads</h1>
            </div>
          </div>
        </div>
      </div>
      <div>
        {results.length > 0 ? (
          <table className="table  table-hover">
            <thead>
              <tr>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  SR No
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Name
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Email
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Phone
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Property Name
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Date
                </th>
                <th style={{ border: "1px solid black", padding: "8px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {results.map((lead) => (
                <tr key={lead._id}>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {results.indexOf(lead) + 1}
                  </td>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {lead.name}
                  </td>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {lead.email}
                  </td>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {lead.mobile}
                  </td>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {lead.subject}
                  </td>
                  <td style={{ border: "1px solid black", padding: "8px" }}>
                    {new Date(lead.date).toLocaleDateString("en-GB")}
                  </td>
                  <td>
                    <input
                      value={followUpValues[lead._id] || ""}
                      onChange={(e) =>
                        handleFollowUpChange(lead._id, e.target.value)
                      }
                      type="text"
                      className="follow-input"
                    />
                  </td>
                  <td>
                    <button
                      onClick={() => updateFollowup(lead._id)}
                      className="btn btn-primary"
                    >
                      Update
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No leads available</p>
        )}
      </div>
      <ToastContainer />
    </>
  );
};

export default Leads;
